var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Ano/Série ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano/Série",
      "counter": "25",
      "maxlength": "25",
      "readonly": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "O que é esperado do aluno",
      "counter": "2500",
      "maxlength": "2500",
      "readonly": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Modalidade de Ensino",
      "readonly": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.modalidade.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content.modalidade, "nome", $$v);
      },
      expression: "content.modalidade.nome"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Quantidade de Bimestres",
      "readonly": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.quantidadeBimestres,
      callback: function ($$v) {
        _vm.$set(_vm.content, "quantidadeBimestres", $$v);
      },
      expression: "content.quantidadeBimestres"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }